import React, { FC, useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import ButtonGroup from '@mui/material/ButtonGroup';
import clsx from 'clsx';
import { RadioOptions } from '../../../../FormFields/RadioButton';
import { SignUpFormData, TRole } from '../../../../../models/auth';
import { TAuthMessages } from '../../../@types';
import Typo from '../../../../Typo';
import styles from './selectRole.module.sass';
import Button from '../../../../Button';

export const ROLE_OPTIONS: RadioOptions[] = [
  {
    name: 'Student',
    value: TRole.STUDENT,
    id: TRole.STUDENT,
  },
  { name: 'Educator', value: TRole.TEACHER, id: TRole.TEACHER },
  // { name: "Mentor", value: TRole.MENTOR, id: TRole.MENTOR },
];

export interface SelectRole {
  valueKey: string;
  formikProps: FormikProps<Partial<SignUpFormData>>;
  messages: TAuthMessages;
  role?: string;
  setRole?: any;
  requestError?: string | undefined;
  requestSuccess?: string | undefined;
}

const SelectRole: FC<SelectRole> = props => {
  const [roleSelected, setRoleSelected] = useState<number>(1);
  const { formikProps, role, setRole, requestError, requestSuccess } = props;
  // const rolePopover = messages["Signup - Who you are?"];
  // const error = getFieldError(valueKey, formikProps);
  useEffect(() => {
    if (role) {
      formikProps.setFieldValue('role', role);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);
  // If the role is mentor, we don't need to render this form
  if (role === TRole.MENTOR) {
    return null;
  }
  return (
    <div className={styles.root}>
      {requestError && (
        <div
          className={styles.requestError}
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: requestError }}
        />
      )}
      {requestSuccess && (
        <div
          className={styles.requestSuccess}
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: requestSuccess }}
        />
      )}
      <Typo normal bold>
        <Typo h3 bold classes={styles.header}>
          Join KnoPro as a
        </Typo>
        <ButtonGroup variant="contained" aria-label="outlined primary button group">
          <Button
            className={clsx(
              styles.pillButton,
              styles.pillButtonLeft,
              roleSelected === 1 && styles.pillButtonSelected,
            )}
            onClick={() => {
              formikProps.setFieldValue('role', TRole.STUDENT);
              setRoleSelected(1);
              setRole(TRole.STUDENT);
            }}
          >
            High School Student
          </Button>
          <Button
            className={clsx(
              styles.pillButton,
              styles.pillButtonRight,
              roleSelected === 2 && styles.pillButtonSelected,
            )}
            onClick={() => {
              formikProps.setFieldValue('role', TRole.TEACHER);
              setRoleSelected(2);
              setRole(TRole.TEACHER);
            }}
          >
            Educator
          </Button>
        </ButtonGroup>
      </Typo>
    </div>
  );
};

export default SelectRole;
